import { Component, OnInit } from '@angular/core';
import {Azienda} from "../../../Admin/models/Azienda";
import {AuthenticationService} from "../../_services/authentication.service";
import {Location} from "@angular/common";
import {ToastrService} from "ngx-toastr";
import {ClassicType} from "../../../shared/models/ClassicType";
import { ApiRestService } from 'src/app/Admin/_service/api-rest.service';
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {TermsComponent} from "../terms/terms.component";
import {ActivatedRoute} from "@angular/router";
import { environment } from 'src/environments/environment';
import {Persona} from "../../../Admin/models/persona";
import {TranslateService} from "@ngx-translate/core";
import {Permission} from "../../_guards/Permission";

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html'
})
export class SignUpComponent implements OnInit {
  environment = environment;
  type: string
  User:Azienda = new Azienda();
  UserTypes: ClassicType[] = [];
  SelectedUserTypes: any[];
  NominativoRequired: boolean = true;
  dropdownSettings:IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField:'id',
    textField: 'label'
  };
  mostrapassword: boolean;
  constructor(private AuthSvc: AuthenticationService,
              private location: Location,
              private toastrService: ToastrService,
              private apiRestService: ApiRestService,
              private ngbModal: NgbModal,
              private route: ActivatedRoute,
              private translate:TranslateService,
              public permission:Permission
  ) {
  }

  ngOnInit(): void {
    this.User.referenti.push(new Persona());
    this.route.params.subscribe(data => {
      this.type = data['type'];
      if(!this.type)
        this.apiRestService.getTipologieClienti().subscribe(data=> this.UserTypes = data);
      else
        this.User.ruoli = [this.type.toUpperCase()];
    })

  }
  openTerms(){
    this.ngbModal.open(TermsComponent,{
      centered: true,
      backdrop: 'static',
      size: 'lg',
    })

  }
  OnTypeChange(){
    // this.NominativoRequired = this.SelectedUserTypes && !this.SelectedUserTypes.find(x=>x.id == 62);
    // this.User.nominativo = '';
  }
  SignUp() {
    if(this.User)
    this.User.username = this.User?.email;
    if(!this.type)
      this.User.tipi = this.GetClassicTypeIds(this.SelectedUserTypes);
    if(!this.User.privacy){
      this.toastrService.warning(this.translate.instant('cliente.privacymsg'))
      return;
    }
    if(this.User?.password != this.User?.password_confirmation) {
      this.toastrService.warning(this.translate.instant('cliente.pwsame'))
      return
    }
    this.AuthSvc.signUp(this.User).subscribe(data=>{
      this.toastrService.warning("Registrazione avvenuta con successo.\n Attendere l'email di conferma")
      this.User = new Azienda();
    })
  }
  GetClassicTypeIds(value: ClassicType[]): string[] {
    var out: string[] = [];
    value?.forEach(element=>out.push(element.id));
    return out;
  }

  mostrapw() {
    this.mostrapassword = !this.mostrapassword;
  }
}
